import { IUseFetchOptionsParams } from '@common/api.models';
import { FETCH_QUERIES_NAME } from '@common/constants';
import { createUseFetchCheckBoxOptionsFn } from '@common/selectOptions.services';
import { getReasonOfChangeOptionsAsync } from './reasonOfChange.services';

export const useFetchReasonOfChangeOptions = ({
  isDirty = true,
  shouldConvertOptions = false,
}: IUseFetchOptionsParams) =>
  createUseFetchCheckBoxOptionsFn({
    queryName: FETCH_QUERIES_NAME.REASON_OF_CHANGE_OPTIONS,
    getOptionsFn: getReasonOfChangeOptionsAsync,
    handleOptionsProps: { textFieldName: 'reasonOfChangeDesc', shouldConvertOptions },
    enabled: !isDirty,
  });
